import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const checkList = svgToTinyDataUri(
  `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 3.00065L2.33333 4.33398L4.33333 2.33398" stroke="#AFE321" stroke-linecap="round"/>
<rect x="6" y="2.66797" width="9.33333" height="1.33333" rx="0.666667" fill="#AFE321"/>
<path d="M1 7.66667L2.33333 9L4.33333 7" stroke="#AFE321" stroke-linecap="round"/>
<rect x="6" y="7.33398" width="9.33333" height="1.33333" rx="0.666667" fill="#AFE321"/>
<path d="M1 12.3346L2.33333 13.668L4.33333 11.668" stroke="#AFE321" stroke-linecap="round"/>
<rect x="6" y="12.002" width="9.33333" height="1.33333" rx="0.666667" fill="#AFE321"/>
</svg>`
);
